var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Startseite")]),_c('div',{staticClass:"card-body"},[_vm._v(" Bitte wählen Sie eine Aktion im Menü aus. ")])])
}]

export { render, staticRenderFns }